module.exports = __webpack_public_path__ + "img/IMG_1539_L_Foamcore.a7796fd5.jpg";